import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import SecurityDeviceIcon from '../../../../Icon/Svg/SecurityDeviceIcon';
import SecurityDocumentIcon from '../../../../Icon/Svg/SecurityDocumentIcon';
import SecurityPeopleIcon from '../../../../Icon/Svg/SecurityPeopleIcon';
const ProffitSearchLandingPageSecuritiesIcons = () => {
    const icons = useMemo(() => [
        {
            description: 'アップロードされたファイルは暗号化して保存されており、万一の漏洩時にも第三者によるデータの読み取りを防ぎます。',
            icon: _jsx(SecurityDocumentIcon, {}),
            title: 'ファイルを守る',
        },
        {
            description: '2段階認証の有効化やログインポリシーの強化により、強力なユーザー認証を組み込み、第三者による不正アクセスを防ぎます。',
            icon: _jsx(SecurityPeopleIcon, {}),
            title: 'アカウントを守る',
        },
        {
            description: 'スライドの個人利用を防止するため、必要なメンバーと社用の承認済みデバイスのみが情報にアクセスできるよう制限しています。',
            icon: _jsx(SecurityDeviceIcon, {}),
            title: 'ファームの知見を守る',
        },
    ], []);
    return (_jsx("div", Object.assign({ className: 'proffit_search_landing_page_securities_icons' }, { children: icons.map((v, i) => (_jsxs("div", Object.assign({ className: 'list_item' }, { children: [_jsx("div", Object.assign({ className: 'item_icon' }, { children: v.icon })), _jsxs("h5", Object.assign({ className: 'item_title' }, { children: [_jsx("span", Object.assign({ className: 'title_number' }, { children: `0${i + 1}` })), _jsx("span", Object.assign({ className: 'title_text' }, { children: v.title }))] })), _jsx("div", Object.assign({ className: 'item_description' }, { children: v.description }))] }), v.title))) })));
};
export default ProffitSearchLandingPageSecuritiesIcons;
